import Image from 'next/image';
import { cn } from '@/lib/utils';

export interface CardProps {
  src: string;
  alt?: string | null;
  title: string;
  description?: string;
}

export default function SpacesCard({ card }: { card: CardProps }) {
  return (
    <div
      className={cn(
        'group relative aspect-video w-full overflow-hidden rounded-xl bg-muted transition-all duration-300 ease-in-out dark:border dark:border-white/10',
      )}
    >
      <Image
        src={card.src}
        alt={card.alt ?? ''}
        fill
        sizes="(max-width: 767px) calc(100vw - 2rem), (max-width: 1279px) calc((100vw - 3rem) / 2), 411px"
        className="object-cover"
      />
      <div className="pointer-events-none absolute inset-0 z-20 bg-[linear-gradient(180deg,rgba(0,0,0,0.24)_0%,rgba(0,0,0,0)_26%,rgba(0,0,0,0)_38%,rgba(0,0,0,0.82)_100%)]" />
      <div
        className={cn(
          'absolute inset-0 z-30 flex flex-col items-start justify-end p-4 transition-opacity duration-300 space-y-0.5',
          'opacity-90 group-hover:opacity-100',
        )}
      >
        <div
          className={`text-base sm:text-lg font-medium tracking-tight text-white ${card.description ? '' : 'leading-none'}`}
        >
          {card.title}
        </div>
        {card.description ? (
          <p className="text-pretty font-light text-xs leading-tight text-white/90 line-clamp-2">
            {card.description}
          </p>
        ) : null}
      </div>
    </div>
  );
}
